
// Configuration Setting URL
export const ConfigurationSettingRoleUrl = ['/add_role'];

export const ConfigurationSettingGeneralUrl = ['/general_configuration/site', '/general_configuration/currency', '/general_configuration/designations', '/general_configuration/document_types', '/general_configuration/hrm_document_types', '/general_configuration/isc_document_types', '/general_configuration/my_dashboard', '/general_configuration/organization', '/general_configuration/site_grouping', '/general_configuration/site_productivity', '/general_configuration/workstation',]

export const ConfigurationSettingAssetsUrl = ['/configuration/asset', '/configuration/asset_matrix', '/configuration/asset_type_grouping', '/configuration/attachment', '/configuration/counterlog', '/configuration/downtime', '/configuration/rental', '/configuration/engagement_time', '/configuration/fuel_feedin', '/configuration/fuel_vendor_configuration', '/configuration/fuel_receiver_configuration', '/configuration/material', '/configuration/productivity', '/configuration/sub-assembly', '/configuration/task_workflow', '/configuration/ticket', '/configuration/transaction_delay',]

export const ConfigurationSettingsInventoryUrl = ['/inventory_configuration/allocation', '/inventory_configuration/consumption', '/inventory_configuration/inventory', '/inventory_configuration/inventory_adjustment', '/inventory_configuration/item_demand', '/inventory_configuration/item', '/inventory_configuration/item_configuration', '/inventory_configuration/logistic_configuration', '/inventory_configuration/manufacturer', '/inventory_configuration/purchase', '/inventory_configuration/purchase_order', '/inventory_configuration/purchase_return', '/inventory_configuration/requisition', '/inventory_configuration/tax_rates', '/inventory_configuration/uom', '/inventory_configuration/warehouse_indent']

export const ConfigurationSettingsHrmUrl = ['/hrm_configuration/:config']

export const ConfigurationSettingsSalesUrl = ['/sales_configuration/allocation', '/sales_configuration/customer_projects', '/sales_configuration/deals', '/sales_configuration/quotation', '/sales_configuration/sales_invoice', '/sales_configuration/sales_order',]

export const ConfigurationSettingsOpeningBalanceUrl = ['/item_opening_balance/add', '/item_opening_balance/update']

// Resource URL
export const ResourceAssetMatrixUrl = ['/asset_matrix/details/:id', '/asset_matrix/scs_setting/:id', '/asset_matrix/settings/:id', '/asset_matrix/compliance/:id', '/asset_matrix/document/:id', '/asset_matrix/additionalattribute/:id','/asset_matrix/add_asset']
export const ResourceInvoiceRuleUrl = ['/invoice_rule_add']

// GroupData URL 
export const groupDataCustomerUrl = ['/customer/add', '/customer/update']
export const groupDataFuelStationUrl = ['/fuelstation_add']
export const groupDataSubAssemblyUrl = ['/sub_assembly/:id?', '/sub_assembly_add', '/sub_assembly_update']
export const groupDataUserUrl = ['/user_add']
export const groupDataVendorUrl = ['/vendor/add', '/vendor/update']
export const groupDataWarehouseUrl = ['/warehouse/add', '/warehouse/update']
export const groupDataWorkstationUrl = ['/workstation_add']

// Productivity URL
export const siteProductivityReportUrl = ['/site_productivity_configuration_add', '/site_productivity_configuration/:id?']
export const siteProductivityListUrl = ['/site_productivity/add']
export const assetProductivityReportUrl = ['/asset_productivity_configuration_add', '/asset_productivity_configuration/:id?']

//ProjectManagement URL 
export const projectUrl= ['/project/:id', '/project_add','/project_edit/:id']

//AccountModule  URL
export const accountModuleExpenseUrl = ['/expense_list/:id?','/payment_add']
export const accountModuleWalletUrl =['/wallet/add','/wallet/update']

//HRModule URL 
export const HRModuleEmployeeUrl =['/employee_add']

//SalesCrm URL
export const SalesCrmCustomerProjectUrl =['/customer_project_add']
export const SalesCrmDealstUrl =['/deals/add']
export const SalesCrmQuotationtUrl =['/quotation_add']
export const SalesCrmSalesOrdertUrl =['/sales_order_add']
export const SalesCrmSalesAllocationtUrl =['/sales_allocation_add']
export const SalesCrmSalesInvoicetUrl =['/sales_invoice_add']

//InventoryModule
export const InventoryModuleItemUrl =['/item_list/add_item','/item_list/update_item']
export const InventoryModuleWareHouseIndentUrl =['/warehouse_indent_add']
export const InventoryPurchaseRequisitionUrl =['/requisition_list/add']
export const InventoryPurchaseOrderUrl =['/purchase_order/add']
export const InventoryPurchaseUrl =['/purchase_list/add','purchase_list/:id?','/purchase_list/update']
export const InventoryPurchaseReturnUrl =['/purchase_return_add']
export const InventoryItemDemandUrl =['/item_demand_add']
export const InventoryAllocationUrl =['/allocation_list/add']
export const InventoryConsumptionUrl =['/consumption_list/add']
export const InventoryTransferUrl =['/inventory_transfer_list/add']
export const InventoryAdjustmentUrl =['/inventory_adjustment_add']
export const InventoryLogisticUrl =['/logistic_add']

//Transactions
export const TransactionsTicketUrl =['/ticket/add']

//Assets
export const MeasurableAssetUrl=['/asset/:tab/:id','/add_asset/:id']











